import { Grid } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import RxBox from "../../../components/RxBox";
import RxCheckBox from "../../../components/RxCheckBox";
import RxTypography from "../../../components/RxTypography";
import { RxPaymentObject } from "../PaymentObject";
import { PaymentStepFormValidationObject } from "../PaymentPage";
import styles from "./PaymentInfoApproveStep.module.css";
import PaymentInfoApproveStepValidation from "./PaymentInfoApproveStepValidation";

interface PaymentInfoApproveStepProps {
	setValidataResult?: any;
	values: RxPaymentObject;
}

const PaymentInfoApproveStep = (props: PaymentInfoApproveStepProps) => {
	const formik = useFormik({
		initialValues: props.values,
		validationSchema: PaymentInfoApproveStepValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			// Form submit edilmediği için bulunuyor. (Sonar uyarısı için)
			console.log("No submit button for this form...");
		},
	});

	useEffect(() => {
		if (!formik.isValid) {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: PaymentStepFormValidationObject
					): PaymentStepFormValidationObject => {
						return {
							...prev,
							isApproveStepValid: false,
						};
					}
				);
		} else {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: PaymentStepFormValidationObject
					): PaymentStepFormValidationObject => {
						return {
							...prev,
							isApproveStepValid: true,
						};
					}
				);
		}
	}, [formik.isValid]); // eslint-disable-line

	useEffect(() => {
		props.setValidataResult &&
			props.setValidataResult(
				(
					prev: PaymentStepFormValidationObject
				): PaymentStepFormValidationObject => {
					return {
						...prev,
						values: {
							...formik.values,
						},
					};
				}
			);
	}, [formik.values]); // eslint-disable-line

	useEffect(() => {
		formik.validateForm();
	}, []); // eslint-disable-line

	return (
		<form>
			<Grid container direction="row" spacing={5}>
				<Grid item xs={12} sm={12}>
					{/* Ödeme Bilgileri */}
					<Grid container spacing={1}>
						<Grid item xs={12} sm={12}>
							<Grid
								container
								spacing={1}
								className={styles.defaultBorder}
							>
								<Grid
									item
									xs={12}
									sm={12}
									className={styles.defaultBorder}
								>
									<RxBox
										label={
											"Ödenecek Tutar: " +
											formik.values.saleDetail.totalPriceWithKdv.toFixed(
												2
											) +
											" TL (KDV Dahil)"
										}
										className={styles.fontBoldWithMargin}
									/>
								</Grid>
								{/* <Grid item xs={2} sm={2}></Grid> */}
							</Grid>
						</Grid>
					</Grid>
					{/* Fatura / Teslimat Bilgileri */}
					<Grid container spacing={1}>
						<Grid item xs={12} sm={12}>
							<Grid
								container
								spacing={1}
								className={styles.topMarginThirty}
							>
								<Grid
									item
									xs={12}
									sm={6}
									className={styles.defaultBorderWithPaddingTwenty}
								>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<RxTypography
												variant="body1"
												align="center"
												color="primary"
												label="Fatura Bilgileri"
												className={styles.titleBackground}
											/>
										</Grid>
									</Grid>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<Grid
												container
												spacing={1}
												className={styles.customPadding}
											>
												<Grid item xs={12} sm={12}>
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.invoiceInfo
																		.isCompany
																		? "Kurum / Firma:"
																		: "Ad Soyad:"
																}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.invoiceInfo
																		.isCompany
																		? formik.values
																				.invoiceInfo.company
																		: formik.values
																				.invoiceInfo
																				.nameSurname
																}
															/>
														</Grid>
													</Grid>
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.invoiceInfo
																		.isCompany
																		? "Vergi Dairesi"
																		: "TC Kİmlik No:"
																}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.invoiceInfo
																		.isCompany
																		? formik.values
																				.invoiceInfo
																				.taxAdmin
																		: formik.values
																				.invoiceInfo
																				.identityId
																}
															/>
														</Grid>
													</Grid>
													{formik.values.invoiceInfo.isCompany && (
														<Grid container spacing={1}>
															<Grid item xs={12} sm={3}>
																<RxTypography
																	variant="body1"
																	align="left"
																	label={"Vergi No:"}
																/>
															</Grid>
															<Grid item xs={12} sm={9}>
																<RxTypography
																	variant="body1"
																	align="left"
																	label={
																		formik.values.invoiceInfo
																			.taxNo
																	}
																/>
															</Grid>
														</Grid>
													)}
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={"Adres:"}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.invoiceInfo
																		.address +
																	" " +
																	formik.values.invoiceInfo
																		.province +
																	"/" +
																	formik.values.invoiceInfo
																		.district +
																	"/" +
																	formik.values.invoiceInfo
																		.country
																}
															/>
														</Grid>
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									sm={6}
									className={styles.defaultBorderWithPaddingTwenty}
								>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<RxTypography
												variant="body1"
												align="center"
												color="primary"
												label="Teslimat Bilgileri"
												className={styles.titleBackground}
											/>
										</Grid>
									</Grid>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<Grid
												container
												spacing={1}
												className={styles.customPadding}
											>
												<Grid item xs={12} sm={12}>
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={"İlgili Kişi:"}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.deliveryInfo
																		.nameSurname
																}
															/>
														</Grid>
													</Grid>
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={"Telefon:"}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.deliveryInfo
																		.phone
																}
															/>
														</Grid>
													</Grid>
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={"Kurum / Firma:"}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.deliveryInfo
																		.company
																}
															/>
														</Grid>
													</Grid>
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={"Adres:"}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.deliveryInfo
																		.address +
																	" " +
																	formik.values.deliveryInfo
																		.province +
																	"/" +
																	formik.values.deliveryInfo
																		.district +
																	"/" +
																	formik.values.deliveryInfo
																		.country
																}
															/>
														</Grid>
													</Grid>
													<Grid container spacing={1}>
														<Grid item xs={12} sm={3}>
															<RxTypography
																variant="body1"
																align="left"
																label={"Not:"}
															/>
														</Grid>
														<Grid item xs={12} sm={9}>
															<RxTypography
																variant="body1"
																align="left"
																label={
																	formik.values.deliveryInfo
																		.note
																}
															/>
														</Grid>
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					{/* Sözleşme Onay */}
					<Grid container spacing={1} className={styles.topMarginThirty}>
						<Grid item xs={12} sm={12}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant="body1"
										align="left"
										label="Siparişiniz onaylandığında lisans numaranız, program indirme adresi ile birlikte tarafınıza e-posta olarak iletilecektir."
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant="body1"
										align="left"
										label="Ödemeniz 3D güvenli ödeme şeklinde gerçekleşecektir."
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid
									item
									xs={12}
									sm={12}
									className={styles.customStyleForKvkkCheck}
								>
									<RxCheckBox
										checked={formik.values.isAgreementApprove}
										outOnChange={formik.handleChange}
										outId="isAgreementApprove"
										outName="isAgreementApprove"
									/>
									<span className={styles.customKvkkText}>
										<a
											href="#/sale-contract"
											target="_blank"
											rel="noreferrer"
										>
											Mesafeli Satış Sözleşmesini
										</a>{" "}
										ve{" "}
										<a
											href="#/security-policy"
											target="_blank"
											rel="noreferrer"
										>
											Güvenlik Politikasını
										</a>{" "}
										okudum, kabul ediyorum.
									</span>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
};

export default PaymentInfoApproveStep;
